import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Layout, TagGroup, Tag, TextButton, Headline, } from '@oneaudi/unified-web-alpha-components';
import { useEffect, useState } from 'react';
import { useTracking } from '../../hooks/use-tracking';
import { useI18n } from '../../i18n/i18n';
import { useCarlineStore } from '../../store/carline';
import { EventAction } from '../../types/tracking';
export const TagSelection = ({ title, subTitle, maxTagsToShow = 20, tags, selectedTags, onSelect, onResetFilters, }) => {
    const { i18n } = useI18n();
    const { compare } = useCarlineStore();
    const [isExpanded, setIsExpanded] = useState(false);
    const { handleTrackEvent, handleUpdateComponentInfo, baseTrackingEventName } = useTracking();
    const handleShowMoreTrackEvent = () => {
        const eventName = `${baseTrackingEventName} - show ${isExpanded ? 'less' : 'more'} filters`;
        const label = isExpanded
            ? i18n('compareLayer.header.tagSelection.showLess')
            : i18n('compareLayer.header.tagSelection.showMore');
        handleTrackEvent({
            eventInfo: {
                eventName,
                eventAction: EventAction.Navigation,
            },
            attributes: {
                label,
                elementName: 'text link',
            },
        });
    };
    const handleResetFiltersTrackEvent = () => {
        const eventName = `${baseTrackingEventName} - remove all filters`;
        handleTrackEvent({
            eventInfo: {
                eventName,
                eventAction: EventAction.Filter,
            },
            attributes: {
                label: i18n('compareLayer.header.tagSelection.resetFilters'),
                elementName: 'tag',
                relatedFilters: [
                    {
                        id: 'category',
                        values: tags.filter((tag) => selectedTags.includes(tag.key)).map((tag) => tag.key),
                    },
                ],
            },
        });
    };
    const handleSelectTagTrackEvent = (tag) => {
        const tagExists = selectedTags.includes(tag.key);
        const eventName = `${baseTrackingEventName} - ${tagExists ? 'remove' : 'add'} filter`;
        handleTrackEvent({
            eventInfo: {
                eventName,
                eventAction: EventAction.Filter,
            },
            attributes: {
                label: tag.label,
                elementName: 'tag',
                relatedFilters: [
                    {
                        id: 'category',
                        values: [tag.key],
                    },
                ],
            },
        });
    };
    useEffect(() => {
        handleUpdateComponentInfo({
            attributes: {
                search: {
                    name: 'engine and trim comparison',
                    term: '',
                    results: compare ? 2 : 1,
                    filter: selectedTags.length > 0
                        ? [
                            {
                                id: 'category',
                                values: tags
                                    .filter((currentTag) => selectedTags.includes(currentTag.key))
                                    .map((currentTag) => currentTag.key),
                            },
                        ]
                        : [],
                },
            },
        });
    }, [selectedTags, tags, handleUpdateComponentInfo, compare]);
    return (_jsxs(Layout, { direction: "column", rowGap: "10px", children: [_jsx(Headline, { tag: "div", variant: {
                    type: 'headline',
                    order: '4',
                    weight: 'normal',
                }, children: title }), subTitle && _jsx(Text, { variant: { order: '2', style: 'normal' }, children: subTitle }), _jsx(TagGroup, { size: "md", margin: ['10px', 0, 0, 0], children: tags.slice(0, isExpanded ? tags.length : maxTagsToShow).map((tag) => (_jsx(Tag, { label: tag.label, size: "md", variant: "selectable", value: tag.value, onChange: () => {
                        onSelect(tag.key);
                        handleSelectTagTrackEvent(tag);
                    }, checked: tag.key === 'emissionData' ? true : selectedTags.includes(tag.key), disabled: tag.key === 'emissionData' }, tag.key))) }), _jsxs(Layout, { margin: ['10px', 0, 0, 0], children: [tags.length > maxTagsToShow && (_jsx(TextButton, { icon: isExpanded ? 'line' : 'add', iconPosition: "leading", onClick: () => {
                            handleShowMoreTrackEvent();
                            setIsExpanded(!isExpanded);
                        }, size: "sm", title: "Title", variant: "tertiary", children: isExpanded
                            ? i18n('compareLayer.header.tagSelection.showLess')
                            : i18n('compareLayer.header.tagSelection.showMore') })), _jsx(TextButton, { icon: "refresh", iconPosition: "leading", disabled: selectedTags.length === 0, onClick: () => {
                            handleResetFiltersTrackEvent();
                            onResetFilters();
                        }, size: "sm", title: "Title", variant: "tertiary", children: i18n('compareLayer.header.tagSelection.resetFilters') })] })] }));
};
